export const mavenChapters = [
  { id: 'ambition', number: '01', label: 'The ambition', range: [0, 3] },
  { id: 'complexity', number: '02', label: 'Make it visible', range: [4, 7] },
  { id: 'build', number: '03', label: 'Build to learn', range: [8, 11] },
  { id: 'judgement', number: '04', label: 'Judgement under pressure', range: [12, 16] },
  { id: 'launch', number: '05', label: 'Launch meets reality', range: [17, 20] },
  { id: 'growth', number: '06', label: 'Design the learning system', range: [21, 23] },
];

export const mavenStory = [
  {
    title: 'Designing the business behind the screen.',
    body: ['From idea to launch to growth with Maven Clinic.'],
    kicker: 'Maven Clinic · 2025—26',
    signal: 'The screen was the last 10%.',
    kind: 'hero',
  },
  {
    title: 'A new relationship.',
    body: [
      'Maven built its reputation by helping women access care through their employers.',
      'The next move was different: build a direct relationship with consumers.',
    ],
    kicker: 'The context',
    signal: 'B2B2C → DTC',
    kind: 'shift',
  },
  {
    title: 'This was not a new feature.',
    body: ['It was a new consumer business inside a 600-person healthcare company.'],
    kicker: 'The ambition',
    signal: 'A startup inside Maven.',
    kind: 'statement',
  },
  {
    title: 'Three front doors.',
    body: ['GLP-1 Care. Hormone Care. A Virtual Clinic.'],
    kicker: 'The launch proposition',
    signal: '01  /  02  /  03',
    kind: 'offering',
  },
  {
    title: 'The simplicity was deceptive.',
    body: ['Behind those three doors: medical eligibility, payment, insurance, prescribing, pharmacy fulfilment and ongoing care.'],
    kicker: 'The hidden complexity',
    signal: 'One interface. Seven systems.',
    kind: 'system',
  },
  {
    title: 'My mandate crossed the whole thing.',
    body: ['I joined as the senior product design partner in the trenches.', 'Help the team decide what to build—and build the thing right.'],
    kicker: 'Strategy to shipped product',
    signal: 'Research · Product · Service · Growth',
    kind: 'role',
  },
  {
    title: 'Start outside the building.',
    body: ['I audited Maven’s existing experience, then studied the patterns shaping consumer health.'],
    kicker: 'Category audit',
    signal: 'Learn the category. Find the gap.',
    kind: 'research',
  },
  {
    title: 'The first useful artefact was not a polished screen.',
    body: ['It was a rough map of what a customer would need to survive the entire journey.'],
    kicker: 'Service design',
    signal: 'Draw the whole service.',
    kind: 'map',
  },
  {
    title: 'Wireframes became questions.',
    body: ['Every rough screen gave product, clinical and engineering something concrete to disagree with.', 'That is how the unknowns surfaced.'],
    kicker: 'Design as discovery',
    signal: 'Make disagreement useful.',
    kind: 'process',
  },
  {
    title: '50–100 wireframes per sprint.',
    body: ['The goal was not volume. It was faster truth.'],
    kicker: 'Speed with a purpose',
    signal: 'Faster truth.',
    kind: 'metric',
  },
  {
    title: 'Build the scaffold first.',
    body: ['Home showed the next essential task.', 'Prescription pages showed state, safety and what came next.'],
    kicker: 'Product architecture',
    signal: 'Next task · Current state · What follows',
    kind: 'product',
  },
  {
    title: 'Reuse before reinvention.',
    body: ['We adapted Maven’s existing design system so engineering could build while the new consumer expression was still taking shape.'],
    kicker: 'Design system strategy',
    signal: 'One system. A new expression.',
    kind: 'system',
  },
  {
    title: 'Design the gaps.',
    body: ['Customers do not experience healthcare as a sequence of screens.', 'They experience waiting, uncertainty and hand-offs.'],
    kicker: 'Service states',
    signal: 'Waiting is part of the product.',
    kind: 'statement',
  },
  {
    title: 'Ruthless MVP.',
    body: ['As launch approached, we stripped the experience to the shortest safe path to real care.', 'Reuse what worked. Cut what did not prove the outcome.'],
    kicker: 'Scope',
    signal: 'Keep · Defer · Remove',
    kind: 'decision',
  },
  {
    title: 'The product was still too fragile for a broad beta.',
    body: ['Two weeks before rollout, I pushed for a smaller pilot first.'],
    kicker: 'The intervention',
    signal: 'Hundreds → six',
    kind: 'turning-point',
  },
  {
    title: 'Six people found what the plan could not.',
    body: ['Account verification could force people to repeat the entire assessment.', 'Pricing and next steps were still unclear.'],
    kicker: 'Pilot research',
    signal: 'Repeat · Confusion · Abandonment',
    kind: 'research',
  },
  {
    title: 'The decision was the deliverable.',
    body: ['We slowed down, fixed the conversion path and dropped work that did not matter to launch.', 'That protected the customer—and the brand.'],
    kicker: 'Product judgement',
    signal: 'Fix the path. Protect the trust.',
    kind: 'decision',
  },
  {
    title: '19 May 2026.',
    body: ['Maven Consumer launched.', 'Months of complexity disappeared behind one simple switch.'],
    kicker: 'Launch day',
    signal: 'Live.',
    kind: 'launch',
  },
  {
    title: 'Launch was the starting gun.',
    body: ['It was the first moment the most important person entered the room: the customer.'],
    kicker: 'Reality enters',
    signal: 'Forecast → behaviour',
    kind: 'turning-point',
  },
  {
    title: 'A useful contradiction.',
    body: ['Early customers rated the care 4.92/5.', 'But conversion started around 0.5%.'],
    kicker: 'Early snapshot · June 2026',
    signal: '4.92 / 5   ≠   0.5%',
    kind: 'contrast',
  },
  {
    title: 'Research the real decision.',
    body: ['Nine post-launch interviews revealed a chain of confidence from first recognition to the first weeks of care.'],
    kicker: 'Customer evidence',
    signal: 'Recognition → Trust → Cost → Care',
    kind: 'research',
  },
  {
    title: 'Conversion was a system.',
    body: ['We connected ad quality, landing-page promise, onboarding behaviour, price clarity, purchase and retention.', 'It was never just a button colour.'],
    kicker: 'Beyond UI optimisation',
    signal: 'Expectation → Experience → Retention',
    kind: 'system',
  },
  {
    title: 'The signals started to move.',
    body: ['By 7 July, weekly GLP-1 purchases reached 47 and conversion reached 2.5%.', 'Not a victory lap. Evidence that the team was learning where to look.'],
    kicker: 'Cross-functional outcome · July 2026',
    signal: '47 / week   ·   2.5%',
    kind: 'metric',
  },
  {
    title: 'We launched the product.',
    body: ['More importantly, we built a better way to learn what the business should become next.'],
    kicker: 'The outcome',
    signal: '“Translate nuance into simple, user-centred experiences.”',
    attribution: 'Tori Bartlett · VP Product',
    kind: 'quote',
  },
];

export const storyVariants = [
  { id: 'guided', number: '01', label: 'Guided scroll', note: 'Cinematic, continuous' },
  { id: 'deck', number: '02', label: 'Story deck', note: 'Fast, tap-through' },
  { id: 'split', number: '03', label: 'Documentary', note: 'Evidence-led' },
  { id: 'chapters', number: '04', label: 'Director’s cut', note: 'Reader-controlled' },
];
